export default __webpack_public_path__ + "images/680d86b3d3cd17c2e66a5012d9843026-getDiscovered_CA.webp";